import type { Preconnect, Preload } from '~/app/helpers/resourceHints';
import { asPreconnect, asPreload } from '~/app/helpers/resourceHints';

export interface ResourceHints {
  preconnect?: Array<string | Preconnect>;
  preload?: Array<Preload>;
}

export function useResourceHints(resourceHints: ResourceHints, options: { client?: boolean } = {}) {
  if (options.client === false) {
    return;
  }

  const preconnects = resourceHints.preconnect ? resourceHints.preconnect.map(mapPreconnects) : [];
  const preloads = resourceHints.preload ? resourceHints.preload.map(mapPreloads) : [];

  useHead({
    link: [
      ...preconnects,
      ...preloads,
    ],
  });
}

function mapPreconnects(preconnect: string | Preconnect) {
  if (typeof preconnect === 'string') {
    return asPreconnect({ href: preconnect });
  }

  return asPreconnect(preconnect);
}

function mapPreloads(preload: Preload) {
  return asPreload(preload);
}
